'use client'

import { useTranslations } from 'next-intl'

import { Button } from '@graftcode/design-system'

import { PORTAL_ONBOARDING_TEST_IDS } from '@apps/portal-onboarding/portal-onboarding-test-ids.const'
import { usePortalOnboardingStore } from '@apps/portal-onboarding/stores/portal-onboarding.store'

import { usePortalOnboardingDismiss } from '../../hooks'

import styles from '../../PortalTutorial.module.scss'

export function PortalOnboardingWelcome() {
  const t = useTranslations('portalOnboarding')
  const startTour = usePortalOnboardingStore((state) => state.startTour)
  const handleDismiss = usePortalOnboardingDismiss()

  return (
    <div className={styles.welcome}>
      <div
        className={styles.welcomeCard}
        role="dialog"
        aria-modal="true"
        aria-labelledby="portal-onboarding-welcome-title"
        data-testid={PORTAL_ONBOARDING_TEST_IDS.welcome}
      >
        <div className={styles.welcomeHeader}>
          <h2 id="portal-onboarding-welcome-title" className={styles.welcomeTitle}>
            {t('welcome.title')}
          </h2>
        </div>
        <p className={styles.welcomeBody}>{t('welcome.description')}</p>
        <div className={styles.welcomeFooter}>
          <Button
            variant="outlined"
            size="m"
            text={t('welcome.maybeLater')}
            data-testid={PORTAL_ONBOARDING_TEST_IDS.maybeLater}
            onClick={handleDismiss}
          />
          <Button variant="primary" size="m" text={t('welcome.letsGo')} onClick={startTour} />
        </div>
      </div>
    </div>
  )
}
